import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementLakeCreateMutation, useMeasurementLakeDeleteMutation, useMeasurementLakeFindAllQuery, useMeasurementLakeUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import measurementSvg from "../../../assets/images/svg/measurement.svg"
import DeleteModal from "Components/Common/DeleteModal";
import Flatpickr from "react-flatpickr";


const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)

  const { data, error, isFetching } = useMeasurementLakeFindAllQuery(`?lake_id=${id}`);
  const [measurementLakeCreate, measurementLakeCreateResult] = useMeasurementLakeCreateMutation();
  const [measurementLakeUpdate, measurementLakeUpdateResult] = useMeasurementLakeUpdateMutation();
  const [measurementLakeDelete, measurementLakeDeleteResult] = useMeasurementLakeDeleteMutation();

  const [measurementLake, setMeasurementLake] = useState<any>();

  const [contains_water, setContains_waterBoolean] = useState<boolean>(false);
  const [is_clean, setIs_cleanBoolean] = useState<boolean>(false);


  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [measurementList, setMeasurementList] = useState<any>();
  const [meaCount, setMeaCount] = useState<any>();

  const {
    data: commonLake,
    error: commonLakeError,
    isFetching: isCommonLakeFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_lake_mode`);



  useEffect(() => {

    if (measurementLake === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }

    setMeasurementList(data?.data);
    setMeaCount(measurementList?.length);

    const tempContains_water = measurementLake !== null ? measurementLake?.contains_water : false;
    const tempIs_clean = measurementLake !== null ? measurementLake?.is_clean : false;

    setContains_waterBoolean(tempContains_water)
    setIs_cleanBoolean(tempIs_clean)

  }, [measurementLake, commonLake, id, data?.data])


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: measurementLake?.id,
      lake_id: measurementLake?.lake_id,
      average_depth: measurementLake?.average_depth,
      average_width: measurementLake?.average_width,
      lake_code: measurementLake?.lake_code,
      lake_water_surface: measurementLake?.lake_water_surface,
      length: measurementLake?.length,
      maximum_depth: measurementLake?.maximum_depth,
      maximum_width: measurementLake?.maximum_width,
      minimum_depth: measurementLake?.minimum_depth,
      mode: measurementLake?.mode,
      report_autor: measurementLake?.report_autor,
      report_code: measurementLake?.report_code,
      report_name: measurementLake?.report_name,

      measure_date: measurementLake?.measure_date,
      shape: measurementLake?.shape,
      shoreline_length: measurementLake?.shoreline_length,
      water_volume: measurementLake?.water_volume,
      usage_information: measurementLake?.usage_information,
      sanitary_requirements: measurementLake?.sanitary_requirements,
      water_physical_quality: measurementLake?.water_physical_quality,
      feeding_mode: measurementLake?.feeding_mode,
      average_changes: measurementLake?.average_changes,
      cmn_lake_mode: measurementLake?.cmn_lake_mode,
      lake_mode_name: measurementLake?.lake_mode_name,


    },
    validationSchema: Yup.object({
      average_depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      average_width: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("утга оруулна уу !"),
      lake_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      lake_water_surface: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("утга оруулна уу !"),
      length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      maximum_depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      maximum_width: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      minimum_depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_code: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      measure_date: Yup.date().typeError('Он сар өдөр оруулна уу').required("Он сар өдөр оруулна уу !"),
      shape: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      shoreline_length: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_volume: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      sanitary_requirements: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      water_physical_quality: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      feeding_mode: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      average_changes: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmn_lake_mode: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга сонгоно уу !"),


    }),
    onSubmit: (values: any) => {
      if (measurementLake !== null) {
        const updateList = {
          id: measurementLake?.id,
          lake_id: measurementLake?.lake_id,
          average_depth: values.average_depth,
          average_width: values.average_width,
          lake_code: values.lake_code,
          lake_water_surface: values.lake_water_surface,
          length: values.length,
          maximum_depth: values.maximum_depth,
          maximum_width: values.maximum_width,
          minimum_depth: values.minimum_depth,
          mode: values.mode,
          report_autor: values.report_autor,
          report_code: values.report_code,
          report_name: values.report_name,
          measure_date: values.measure_date,
          shape: values.shape,
          shoreline_length: values.shoreline_length,
          water_volume: values.water_volume,
          usage_information: values.usage_information,
          sanitary_requirements: values.sanitary_requirements,
          water_physical_quality: values.water_physical_quality,

          cmn_lake_mode: values.cmn_lake_mode,
          // lake_mode_name: values.lake_mode_name,
          contains_water: contains_water === undefined ? false : contains_water,
          feeding_mode: values.feeding_mode,
          average_changes: values.average_changes,
          is_clean: is_clean === undefined ? false : is_clean,
        }
        measurementLakeUpdate(updateList);
      } else {
        const newList = {
          lake_id: id,
          average_depth: values["average_depth"],
          average_width: values["average_width"],
          lake_code: values["lake_code"],
          lake_water_surface: values["lake_water_surface"],
          length: values["length"],
          maximum_depth: values["maximum_depth"],
          maximum_width: values["maximum_width"],
          minimum_depth: values["minimum_depth"],
          mode: values["mode"],
          report_autor: values["report_autor"],
          report_code: values["report_code"],
          report_name: values["report_name"],
          measure_date: values["measure_date"],
          shape: values["shape"],
          shoreline_length: values["shoreline_length"],
          water_volume: values["water_volume"],
          usage_information: values["usage_information"],
          sanitary_requirements: values["sanitary_requirements"],
          water_physical_quality: values["water_physical_quality"],

          cmn_lake_mode: values["cmn_lake_mode"],
          lake_mode_name: values["lake_mode_name"],
          contains_water: contains_water === undefined ? false : contains_water,
          feeding_mode: values["feeding_mode"],
          average_changes: values["average_changes"],
          is_clean: is_clean === undefined ? false : is_clean,
        };
        measurementLakeCreate(newList)
      }
      validation.resetForm();
    },
  });



  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = () => {
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (measurementLake) {
      measurementLakeDelete(measurementLake.id);
      setDeleteModal(false);
    }
    setMeasurementLake(null);
    setIs_newCreated(true)
  };

  return (

    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label me-3"
              onClick={() => {
                validation.resetForm();
                setMeasurementLake(null);
                setIs_cleanBoolean(false);
                setContains_waterBoolean(false)
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>

            {
              is_newCreated === false && measurementLake !== null ?
                <button
                  type="button"
                  onClick={(event: any) => {
                    event.preventDefault();
                    onClickDelete();
                  }}
                  className="btn btn-danger  btn-label"
                >
                  <i className="mdi mdi-delete-empty-outline label-icon"></i> Устгах
                </button>
                : ''
            }



          </div>
        </Col>
      </Row>
      <Row>
        <DeleteModal
          deleteName={measurementLake?.report_name}
          show={deleteModal}
          onDeleteClick={handleDeletejob}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementLake(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="fw-semibold"> Дундаж урт /м,км/ </Label>
                      <Input
                        name="average_width"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.average_width || ""}
                        invalid={
                          validation.touched.average_width &&
                            validation.errors.average_width
                            ? true
                            : false
                        }
                      />
                      {validation.touched.average_width &&
                        validation.errors.average_width ? (
                        <FormFeedback type="invalid">
                          {validation.errors.average_width}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нуурын гадарга </Label>
                      <Input
                        name="lake_water_surface"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.lake_water_surface || ""}
                        invalid={
                          validation.touched.lake_water_surface &&
                            validation.errors.lake_water_surface
                            ? true
                            : false
                        }
                      />
                      {validation.touched.lake_water_surface &&
                        validation.errors.lake_water_surface ? (
                        <FormFeedback type="invalid">
                          {validation.errors.lake_water_surface}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хамгийн урт /м,км/</Label>
                      <Input
                        name="maximum_width"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.maximum_width || ""}
                        invalid={
                          validation.touched.maximum_width &&
                            validation.errors.maximum_width
                            ? true
                            : false
                        }
                      />
                      {validation.touched.maximum_width &&
                        validation.errors.maximum_width ? (
                        <FormFeedback type="invalid">
                          {validation.errors.maximum_width}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлан гаргасан </Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нуурын эзэлхүүн /м3/</Label>
                      <Input
                        name="water_volume"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_volume || ""}
                        invalid={
                          validation.touched.water_volume &&
                            validation.errors.water_volume
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_volume &&
                        validation.errors.water_volume ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_volume}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглалтын мэдээлэл </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Устай эсэх </Label>
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setContains_waterBoolean(!contains_water);
                        }}
                        checked={contains_water}
                      />

                    </div>

                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Дундаж гүн /м/</Label>
                      <Input
                        name="average_depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.average_depth || ""}
                        invalid={
                          validation.touched.average_depth &&
                            validation.errors.average_depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.average_depth &&
                        validation.errors.average_depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.average_depth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Эргийн шугам урт /м,км/</Label>
                      <Input
                        name="length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.length || ""}
                        invalid={
                          validation.touched.length &&
                            validation.errors.length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.length &&
                        validation.errors.length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">  Хамгийн гүехэн /м/</Label>
                      <Input
                        name="minimum_depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.minimum_depth || ""}
                        invalid={
                          validation.touched.minimum_depth &&
                            validation.errors.minimum_depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.minimum_depth &&
                        validation.errors.minimum_depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.minimum_depth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангын дугаар </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэлбэр </Label>
                      <Input
                        name="shape"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.shape || ""}
                        invalid={
                          validation.touched.shape &&
                            validation.errors.shape
                            ? true
                            : false
                        }
                      />
                      {validation.touched.shape &&
                        validation.errors.shape ? (
                        <FormFeedback type="invalid">
                          {validation.errors.shape}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бохирдол </Label>
                      <Input
                        name="sanitary_requirements"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sanitary_requirements || ""}
                        invalid={
                          validation.touched.sanitary_requirements &&
                            validation.errors.sanitary_requirements
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sanitary_requirements &&
                        validation.errors.sanitary_requirements ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sanitary_requirements}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Түвшний өөрчлөлт </Label>
                      <Input
                        name="average_changes"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.average_changes || ""}
                        invalid={
                          validation.touched.average_changes &&
                            validation.errors.average_changes
                            ? true
                            : false
                        }
                      />
                      {validation.touched.average_changes &&
                        validation.errors.average_changes ? (
                        <FormFeedback type="invalid">
                          {validation.errors.average_changes}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Эрүүл ахуйн шаардлага хангасан эсэх </Label>
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_cleanBoolean(!is_clean);
                        }}
                        checked={is_clean}
                      />

                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нуурын дугаар </Label>
                      <Input
                        name="lake_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.lake_code || ""}
                        invalid={
                          validation.touched.lake_code &&
                            validation.errors.lake_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.lake_code &&
                        validation.errors.lake_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.lake_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хамгийн гүн /м,км/</Label>
                      <Input
                        name="maximum_depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.maximum_depth || ""}
                        invalid={
                          validation.touched.maximum_depth &&
                            validation.errors.maximum_depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.maximum_depth &&
                        validation.errors.maximum_depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.maximum_depth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангын нэр </Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Эргийн урт /м,км/</Label>
                      <Input
                        name="shoreline_length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.shoreline_length || ""}
                        invalid={
                          validation.touched.shoreline_length &&
                            validation.errors.shoreline_length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.shoreline_length &&
                        validation.errors.shoreline_length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.shoreline_length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усны физик чанар </Label>
                      <Input
                        name="water_physical_quality"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_physical_quality || ""}
                        invalid={
                          validation.touched.water_physical_quality &&
                            validation.errors.water_physical_quality
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_physical_quality &&
                        validation.errors.water_physical_quality ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_physical_quality}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Нуур (тойром)-ын горим  </Label>

                      <Input
                        name="cmn_lake_mode"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cmn_lake_mode || ""}
                        invalid={
                          validation.touched.cmn_lake_mode &&
                            validation.errors.cmn_lake_mode
                            ? true
                            : false
                        }
                      >
                        <option disabled value="">Сонгох</option>

                        {commonLake?.data?.map((item, index) => (
                          <option value={item?.id}>{item?.name}</option>
                        ))}

                      </Input>
                      {validation.touched.cmn_lake_mode &&
                        validation.errors.cmn_lake_mode ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cmn_lake_mode}
                        </FormFeedback>
                      ) : null}

                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Тэжээгдлийн горим	 </Label>
                      <Input
                        name="feeding_mode"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.feeding_mode || ""}
                        invalid={
                          validation.touched.feeding_mode &&
                            validation.errors.feeding_mode
                            ? true
                            : false
                        }
                      />
                      {validation.touched.feeding_mode &&
                        validation.errors.feeding_mode ? (
                        <FormFeedback type="invalid">
                          {validation.errors.feeding_mode}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={12} className="d-flex justify-content-around mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>

      </Row>

    </>
  )
}

export default Measurement;